module.exports = __webpack_public_path__ + "img/help4.cd467b17.png";